import { render } from "./change-price.vue?vue&type=template&id=2353dcc0&scoped=true&ts=true"
import script from "./change-price.vue?vue&type=script&lang=tsx"
export * from "./change-price.vue?vue&type=script&lang=tsx"

import "./change-price.vue?vue&type=style&index=0&id=2353dcc0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2353dcc0"]])

export default __exports__